module.exports = __webpack_public_path__ + "static/media/hot22.a960aa5a.jpg";